import Alpine from 'alpinejs';

function render(block) {
  const buttonContainer = block.querySelector('.buttonContainer ul');
  const buttons = block.querySelectorAll('button');

  buttons.forEach((button, index) => {
    const li = document.createElement('li');
    li.classList.add('inline-block');
    li.classList.add('md:relative');
    li.appendChild(button);
    buttonContainer.appendChild(li);
  });
}

function refresh() {
  document.querySelectorAll('.downloadswitch').forEach(block => render(block));
}
Alpine.data('downloadSwitch', () => ({
  activeId: null,
  init() {
    // Render buttons into the side list
    refresh();

    // Initialize activeId from first item marked as opened; fallback to first button
    const preOpenBtn = this.$root.querySelector('button[data-opened="true"]');
    if (preOpenBtn) {
      this.activeId = preOpenBtn.getAttribute('aria-controls');
    } else {
      const firstBtn = this.$root.querySelector('.buttonContainer button, button');
      if (firstBtn) {
        this.activeId = firstBtn.getAttribute('aria-controls');
      }
    }

    const inNeosBackend = window.name == 'neos-content-main';

    // We are in the backend, so we need to watch for changes
    if (inNeosBackend) {
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(node => {
              if (node.classList && node.classList.contains('downloadswitch-item')) {
                refresh();
              }
            });
          }
        }
      });

      observer.observe(document.body, { attributes: true, childList: true, subtree: true });
    }
  }

}));
